import * as React from 'react';
import './ResultPage.css';

interface Props {
  title: string;
  message: string;
  success?: boolean;
}

class ResultPageComponent extends React.PureComponent<Props> {

  render(): React.ReactNode {
    return (
        <section className="success-page">
            <div className="gap-50" />
          {this.props.success === undefined || this.props.success ?
            <span className="corrected-circle"/>
            :
            <span className="alerted-circle"/>
          }
            <div className="gap-50" />
            <p className="text-center">
                <strong className="f-s-16">
                  {this.props.title}
                </strong>
                <br />
            </p>
            <p style={{textAlign: 'center', margin: '15px 100px'}}>
              {this.props.message}
            </p>
            <div className="gap-50" />
        </section>
    );
  }
}

export default ResultPageComponent;


// WEBPACK FOOTER //
// ./src/modules/commons/result-page/ResultPage.Component.tsx